var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomethingWentWrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 108,
    viewBox: "0 0 122 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 32H31V35C31 43.2843 24.2843 50 16 50C7.71573 50 1 43.2843 1 35V32Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24C21 22.8954 21.8954 22 23 22C24.1046 22 25 22.8954 25 24V32H21V24Z",
    fill: "#0E5CF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64C102 62.8954 102.895 62 104 62C105.105 62 106 62.8954 106 64V74C106 75.1046 105.105 76 104 76C102.895 76 102 75.1046 102 74V64Z",
    fill: "#0E5CF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.493 63.0514C110.859 62.1466 111.079 60.8995 111.984 60.2659C112.889 59.6324 114.136 59.8523 114.769 60.7571L120.505 68.9486C121.139 69.8534 120.919 71.1005 120.014 71.7341C119.109 72.3676 117.862 72.1477 117.229 71.2429L111.493 63.0514Z",
    fill: "#0E5CF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2288 60.757C93.8624 59.8521 95.1095 59.6323 96.0143 60.2658C96.9191 60.8994 97.139 62.1465 96.5054 63.0513L90.7697 71.2428C90.1361 72.1476 88.889 72.3675 87.9842 71.7339C87.0794 71.1004 86.8595 69.8533 87.4931 68.9485L93.2288 60.757Z",
    fill: "#0E5CF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24C7 22.8954 7.89543 22 9 22C10.1046 22 11 22.8954 11 24V32H7V24Z",
    fill: "#0E5CF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54V84C16 96.1503 25.8497 106 38 106V106C50.1503 106 60 96.1503 60 84V54",
    stroke: "#20242E",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54V24C60 11.8497 69.8497 2 82 2V2C94.1503 2 104 11.8497 104 24V54",
    stroke: "#20242E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWentWrong);
export default __webpack_public_path__ + "static/media/something-went-wrong.d742e77474af82731d8ba91f658a69a6.svg";
export { ForwardRef as ReactComponent };